var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lazy-video"},[_c('LazyYoutubeVideo',{attrs:{"src":("https://www.youtube.com/embed/" + (_vm.resource.youtubeId))}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.resource.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }